import React, { useEffect, useState } from 'react'
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { notify } from '../toast';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

const AdminDashboard = ({ user }) => {

    const styles = {
        stat: {
            minWidth: 120,
            background: 'var(--secondary-color)',
            borderRadius: 8,
            padding: '10px 14px',
            flex: '0 1 120px',
        },
        statLabel: {
            fontSize: '0.75rem',
            color: '#666',
            marginBottom: 4,
        },
        statValue: {
            fontSize: '1.1rem',
            fontWeight: 'bold',
        },
    };

    const entityMap = {
        0: 'holder',
        1: 'holder',
        2: 'hospital',
        3: 'hospital',
        4: 'employee'
    };
    const [activeIndex, setActiveIndex] = useState(0);
    const [holders, setHolders] = useState([]);
    const [totalHolders, setTotalHolders] = useState(1);
    const [hospitals, setHospitals] = useState([]);
    const [totalHospitals, setTotalHospitals] = useState(1);
    const [employees, setEmployees] = useState([]);
    const [totalEmployees, setTotalEmployees] = useState(1);
    const [villageCount, setVillageCount] = useState(0);
    const [mandalCount, setMandalCount] = useState(0);
    const [districtCount, setDistrictCount] = useState(0);
    const [areaCount, setAreaCount] = useState(0);
    const [cards, setCards] = useState([
        { title: "Total card holders", value: 0 },
        { title: "Total customers", value: 0 },
        { title: "Total hospitals", value: 0 },
        { title: "Total doctors", value: 0 },
        { title: "Total employees", value: 0 },
    ]);

    const [filter, setFilter] = useState('');
    const [entity, setEntity] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState({});

    const [pageLoading, setPageLoading] = useState(false);

    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();

    const fetchAdminDashboard = async () => {
        try {
            setPageLoading(true);

            const response = await axiosPrivate.get(`/admin/getDashboard?page=${Math.max(
                Math.ceil(holders.length / 10) + 1,
                Math.ceil(hospitals.length / 10) + 1,
                Math.ceil(employees.length / 10) + 1,
            )}`);

            const data = response?.data;

            setHolders(prev => [...prev, ...data?.holders]);
            setTotalHolders(data?.totalHolders);

            setHospitals(prev => [...prev, ...data?.hospitals]);
            setTotalHospitals(data?.totalHospitals);

            setEmployees(prev => [...prev, ...data?.employees]);
            setTotalEmployees(data?.totalEmployees);

            setCards([
                { title: "Total card holders", value: data?.totalHolders },
                { title: "Total customers", value: data?.totalCustomers },
                { title: "Total hospitals", value: data?.totalHospitals },
                { title: "Total doctors", value: data?.totalDoctors },
                { title: "Total employees", value: data?.totalEmployees },
            ]);

            setVillageCount(data?.villageCount);
            setMandalCount(data?.mandalCount);
            setDistrictCount(data?.districtCount);
            setAreaCount(data?.areaCount);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {

        fetchAdminDashboard();

        // eslint-disable-next-line
    }, []);

    const fetchFilteredDetails = async () => {
        if (!filter) {
            if (entity !== '') clearFilter();
            return notify('failed', 'Filter cannot be empty');
        }

        const selectedEntity = entityMap[activeIndex];
        setEntity(selectedEntity);

        try {
            const result = await axiosPrivate.get(`/admin/getFilteredDetails?filter=${filter}&entity=${selectedEntity}`);
            setFilteredData(result?.data);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
            clearFilter();
        }
    };

    const clearFilter = () => {
        setEntity('');
        setFilter('');
        setFilteredData([]);
        notify('info', 'Filter cleared');
    }

    const handleHospitalDelete = async (id) => {
        try {
            const result = await axiosPrivate.delete(`/admin/deleteHospital/${id}`);
            notify('success', result?.data?.success)
            setHospitals(prev => prev.filter(hospital => hospital._id !== id));
            setTotalHospitals(prev => prev - 1);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    };

    const handleEmployeeDelete = async (id) => {
        try {
            const result = await axiosPrivate.delete(`/admin/deleteEmployee/${id}`);
            notify('success', result?.data?.success)
            setEmployees(prev => prev.filter(employee => employee._id !== id));
            setTotalEmployees(prev => prev - 1);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    };

    return (
        <div className='container'>
            <div className="dashboard">
                <div className="inner">

                    <h2>Welcome back, <i style={{ color: 'var(--primary-text-color)' }}>{user}</i></h2>

                    <div className="cards-container">

                        {cards.map((card, index) => (
                            <div
                                key={index}
                                className={`card ${activeIndex === index ? "active" : ""}`}
                                onClick={() => setActiveIndex(index)}
                            >
                                <div className="card-body">
                                    <h3 className="card-title">{card.title}</h3>
                                    <h3 className="card-value">{card.value}</h3>
                                </div>
                            </div>
                        ))}

                    </div>

                    <br />

                    <div className="cards-container">
                        <div style={styles.stat}>
                            <div style={styles.statLabel}>Village Clusters</div>
                            <div style={styles.statValue}>{villageCount}</div>
                        </div>
                        <div style={styles.stat}>
                            <div style={styles.statLabel}>Mandal Officers</div>
                            <div style={styles.statValue}>{mandalCount}</div>
                        </div>
                        <div style={styles.stat}>
                            <div style={styles.statLabel}>District Officers</div>
                            <div style={styles.statValue}>{districtCount}</div>
                        </div>
                        <div style={styles.stat}>
                            <div style={styles.statLabel}>Area Managers</div>
                            <div style={styles.statValue}>{areaCount}</div>
                        </div>
                    </div>

                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <input
                        className='formInput'
                        type="text"
                        placeholder='Filter'
                        disabled={entity !== entityMap[activeIndex] && (entity !== '')}
                        value={entity === entityMap[activeIndex] || (entity === '')
                            ? filter
                            : ''}
                        onChange={(event) => setFilter(event.target.value)}
                    />
                </div>
                <div className='formGroup'>
                    <button className="add-btn" disabled={(entity !== '') && (entity !== entityMap[activeIndex])} onClick={fetchFilteredDetails}>Search</button> &nbsp;
                    {entity !== '' && <button className="close-btn" style={{ borderRadius: '10rem' }} onClick={clearFilter}>Clear filter</button>}
                </div>
            </div>

            {// @ts-ignore
                (activeIndex === 0 || activeIndex === 1) && holders?.length !== 0 &&

                <>
                    <section className="user-list">
                        <div className="list-header">
                            <span>Id</span>
                            <span>Name</span>
                            <span>Mobile</span>
                            <span>Member count</span>
                            <span>Action</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                (entity === 'holder' ? filteredData : holders).map((holder) => (
                                    <div
                                        className="list-row employee-row"
                                        key={holder?._id}
                                        onClick={() => navigate(`/holderEdit/${holder?._id}`)}>
                                        <span className='truncate' title={holder?.holderId} data-label="ID">{holder?.holderId}</span>
                                        <span className='truncate' title={holder?.name} data-label="Name">{holder?.name}</span>
                                        <span className='truncate' title={holder?.mobile} data-label="Mobile">{holder?.mobile}</span>
                                        <span className='truncate' title={holder?.members?.length} data-label="Member count">{holder?.members?.length || 0}</span>
                                        <span>
                                            <button className="approve-btn" onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/holderCard/${holder?._id}`);
                                            }}>View Card</button>
                                        </span>
                                    </div>
                                ))
                            }
                        </div>

                    </section>

                    {(totalHolders !== holders.length) && (entity !== 'holder') ?
                        <div>
                            <button className='add-btn' disabled={pageLoading} onClick={fetchAdminDashboard}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                        </div>
                        : <></>
                    }
                    <br />

                </>
            }

            {// @ts-ignore
                (activeIndex === 2 || activeIndex === 3) && hospitals?.length !== 0 &&

                <>
                    <section className="user-list">
                        <div className="list-header">
                            <span>Name</span>
                            <span>Area</span>
                            <span>Email</span>
                            <span>Doctor count</span>
                            <span>Action</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                (entity === 'hospital' ? filteredData : hospitals).map((hospital) => (
                                    <div className="list-row employee-row"
                                        key={hospital?._id}
                                        onClick={() => navigate(`/hospitalPatients/${hospital?._id}`, {
                                            state: {
                                                name: hospital?.name
                                            }
                                        })}
                                    >
                                        <span className='truncate' title={hospital?.name} data-label="Name">{hospital?.name}</span>
                                        <span className='truncate' title={hospital?.area} data-label="Area">{hospital?.area}</span>
                                        <span className='truncate' title={hospital?.email} data-label="Email">{hospital?.email}</span>
                                        <span className='truncate' title={hospital?.doctors?.length} data-label="Doctor count">{hospital?.doctors?.length || 0}</span>
                                        <span>
                                            <button
                                                className="close-btn"
                                                style={{ padding: '7px 10px' }}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setDeleteModalData({ subject: hospital?.name, delete: handleHospitalDelete, id: hospital?._id, event });
                                                    setOpenDeleteModal(true);
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </span>
                                    </div>
                                ))
                            }
                        </div>

                    </section>

                    {(totalHospitals !== hospitals.length) && (entity !== 'hospital') ?
                        <div>
                            <button className='add-btn' disabled={pageLoading} onClick={fetchAdminDashboard}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                        </div>
                        : <></>
                    }
                    <br />

                </>
            }

            {// @ts-ignore
                (activeIndex === 4) && employees?.length !== 0 &&

                <>
                    <section className="user-list">
                        <div className="list-header">
                            <span>Id</span>
                            <span>Name</span>
                            <span>Gender</span>
                            <span>Mobile</span>
                            <span>Email</span>
                            <span>Action</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                (entity === 'employee' ? filteredData : employees).map((employee) => (
                                    <div className="list-row employee-row"
                                        key={employee?._id}
                                        onClick={() => navigate(`/employee/${employee?._id}`, {
                                            state: {
                                                name: employee?.name
                                            }
                                        })}
                                    >
                                        <span className='truncate' title={employee?.employeeId} data-label="ID">{employee?.employeeId}</span>
                                        <span className='truncate' title={employee?.name} data-label="Name">{employee?.name}</span>
                                        <span className='truncate' title={employee?.gender} data-label="Gender">{employee?.gender}</span>
                                        <span className='truncate' title={employee?.mobile} data-label="Mobile">{employee?.mobile}</span>
                                        <span className='truncate' title={employee?.email} data-label="Email">{employee?.email}</span>
                                        <span>
                                            <button
                                                className="approve-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/employeeCard/${employee?._id}`)
                                                }
                                                }>
                                                View Card
                                            </button>
                                            &nbsp;
                                            <button
                                                className="close-btn"
                                                style={{ padding: '7px 10px' }}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setDeleteModalData({ subject: employee?.name, delete: handleEmployeeDelete, id: employee?._id, event });
                                                    setOpenDeleteModal(true);
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </span>
                                    </div>
                                ))
                            }
                        </div>

                    </section>

                    {(totalEmployees !== employees.length) && (entity !== 'employee') ?
                        <div>
                            <button className='add-btn' disabled={pageLoading} onClick={fetchAdminDashboard}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                        </div>
                        : <></>
                    }
                    <br />

                </>
            }

            <Modal
                isOpen={openDeleteModal}
                onRequestClose={() => setOpenDeleteModal(false)}
                style={{
                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                }}
                className='formContainer'
            >
                <div className='formWrapper'>
                    <h2 className='formTitle'>Do you want to delete&nbsp;
                        {// @ts-ignore
                            deleteModalData?.subject}?</h2>
                    <div className='formRow'>
                        <button
                            className='close-btn'
                            style={{ width: '95%' }}
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenDeleteModal(false);
                                setDeleteModalData({})
                            }}>
                            <span>Close</span>
                        </button>
                        <button className="submitButton" onClick={() => {
                            // @ts-ignore
                            deleteModalData?.delete(deleteModalData?.id);
                            setOpenDeleteModal(false);
                        }}>Delete</button>
                    </div>
                </div>
            </Modal >

        </div >
    )
}

export default AdminDashboard
